import * as React from 'react';
import * as styles from './ParagraphPrimary.scss';

interface Props {
    children?: any;
    alignText?: string;
    innerHtml?: boolean;
}

const ParagraphPrimary: React.SFC<Props> = props => {
    const alignTextClass = props.alignText ? styles[props.alignText] : '';
    return props.innerHtml ? (
        <p
            dangerouslySetInnerHTML={{ __html: props.children }}
            className={styles.paragraphPrimary + ' ' + alignTextClass}
        />
    ) : (
        <p className={styles.paragraphPrimary + ' ' + alignTextClass}>
            {props.children}
        </p>
    );
};

export default ParagraphPrimary;
